
/* Generated apis ---------------------- */
import { to } from 'react-lib/utils'
import BaseService from  'react-lib/apis/services/BaseService'
import config from '../../config/config'
import VitalSignValueListSerializer from '../types/VitalSignValueListSerializer_apps_PTM'


const HOST = `${config.API_HOST}`
/* ['generics.ListAPIView'] */
/* params: 'patient', 'encounter', 'latest', 'latest_measurement', 'all_latest_measurement', 'all_latest_history', 'only_always_show', 'type_code', 'patient', 'encounter', 'latest', 'latest_measurement', 'all_latest_measurement', 'all_latest_history', 'only_always_show', 'type_code', 'patient', 'encounter' */
/* data:  */
const VitalSignValueList : 
{
  list:     ({params, apiToken, extra}:
             { 
                params?: any,
                apiToken?: any,
                extra?: any,
            }) => any,
} = 
{
  list: async ({params, apiToken, extra}) => {
    const base = new BaseService()
    if (apiToken)
      base.client.defaults.headers.common["Authorization"] = "Token " + apiToken;
    if (extra?.division)
      base.client.defaults.headers.common["division"] = extra.division;
    if (extra?.device)
      base.client.defaults.headers.common["device"] = extra.device;
    const result = await to(base.client.get(`${HOST}/apis/PTM/vital-sign-value/`,
      { params: params ? { ...params } : {},
         ...extra
      }
    )
    .then(base.handleResponse)
    .catch(base.throwErrorMessage))
    return [result[1], result[0], result[2]]
  },
}

export default VitalSignValueList

